<!--
 * @Description: 重置dialog
 * @Autor: xiaona.wang
 * @Date: 2021-12-01 20:57:00
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2021-12-08 14:10:42
-->
<template>
  <el-dialog
    v-dialogDrag
    class="custom-dialog"
    title=""
    :visible.sync="dialogVisible"
    :width="width"
    :append-to-body="true"
    :close-on-click-modal="false"
    :custom-class="customClass"
    top="24vh"
  >
    <!-- 略微扩展，默认显示警告图标 -->
    <div class="dialog__body--custom">
      <div class="dialog__img">
        <div v-show="ifShowImg" class="hint">
          <svg-icon icon-class="reset" style="width: 1.4em; height: 0.8em;" />
        </div>
      </div>
      <div class="dialog__content">
        <div class="title weightText">{{ content.title }}</div>
        <div class="description primaryText">
          {{ content.description || $t("public.cannotRecovered") }}
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <slot name="footer">
        <el-button plain class="self-button-width" @click="dialogVisible = false">
          {{ $t("public.cancel") }}
        </el-button>
        <el-button type="primary" class="self-button-width" style="margin-left: 20px;"  @click="handleConfirm">{{ $t('public.confirm') }}</el-button>
      </slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "DeleteDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default() {
        return {};
      }
    },
    width: {
      type: String,
      default: "428px"
    },
    loading: {
      type: Boolean,
      default: false
    },
    ifShowImg: {
      type: Boolean,
      default: true
    },
    iconName: {
      type: String,
      default: "hint"
    },
    // 只支持left，top
    layout: {
      type: String,
      default: "top"
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    resetLoading: {
      get() {
        return this.loading;
      },
      set(val) {
        this.$emit("update:loading", val);
      }
    },
    customClass() {
      if (this.layout === "left") {
        return "custom-dialog layout--left";
      } else {
        return "custom-dialog layout--top";
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$emit("confirm");
    }
  }
};
</script>

<style scoped lang="scss">
.custom-dialog {
  ::v-deep .el-dialog__body {
    padding: 0 24px;
  }
  ::v-deep .el-dialog__close {
    color: #505363;
  }
}
.layout--left {
  .dialog__body--custom {
    display: flex;
    flex-direction: row;
    .dialog__img {
      .hint {
        text-align: center;
        color: #ff6417;
        font-size: 24px;
        margin-top: -4px;
      }
    }
    .dialog__content {
      .title {
        line-height: 26px;
        font-size: 16px;
        font-weight: 600;
      }
      .description {
        padding: 10px 0;
        line-height: 20px;
        min-height: 80px;
      }
    }
  }
  .dialog-footer {
    text-align: right;
    padding-bottom: 4px;
    ::v-deep .el-button {
      padding: 8px 16px;
    }
  }
}
// .layout--top {
//   .dialog__body--custom {
//     display: flex;
//     flex-direction: column;
//   }
//   .hint {
//     text-align: center;
//     color: #ffa046;
//     font-size: 78px;
//   }
//   .title {
//     font-size: 18px;
//     font-weight: 500;
//     text-align: center;
//     margin-bottom: 8px;
//   }
//   .description {
//     text-align: center;
//     margin-bottom: 26px;
//   }
//   .dialog-footer {
//     padding-bottom: 10px;
//     text-align: center;
//   }
// }
</style>
